<h1 style="padding-top: 2rem;">Step 1: Reduce Time in Bed</h1>
<div class="row">
    <div class="col-md-6" style="font-family: Karla; font-size : 14px;">
        <p>
            The first step is to reduce your time in bed so that your sleep pressure increases and your drive for sleep becomes higher.

        </p>
        <br>

        <p>
            This step is based on the first principle of sleep pressure. As we have discussed, <strong> “Sleep
                pressure” </strong>
            builds up the longer you are awake during the day. The less time you spend in bed, the more time that
            you are awake, which in turn increases the “sleep pressure.”
        </p>
        <br>
        <p>
            Studies clearly show that for people with insomnia, staying awake longer leads to several
            positive effects, including falling asleep faster, sleeping deeply, and having fewer awakenings
            during sleep-- which improves one’s sleep quality resulting in a “ better sleep”.

        </p>

        <br>
        <p>
            When we say to decrease time in bed, we are not really aiming to decrease the amount of sleep you get
            in bed, but the amount of wakefulness you have in bed. Think of it this way.

        </p>
        <br>

        <p>
            Your brain is only able to produce so much sleep per 24 hours, and people with insomnia are usually
            able to produce less sleep than other people. If your brain is able to get 5-7 hours of actual sleep
            at night, but you spend 8 hours in bed, then you will inevitably have 1-3 hours of wakefulness or
            poor-qualify of sleep in bed. That can lead to more frustration which can perpetuate your insomnia
            symptoms.
        </p>
    </div>
    <div class="col-md-6">
        <div class="row justify-content-around">
            <img src="/assets/actionplan-step1-1.png" style="width: 70%;"/>
            <q style="width: 90%;">
                Staying awake longer leads to several positive effects
            </q>  
        </div>
        <br><br><br><br><br>
        <div class="row justify-content-around">
            <img src="/assets/actionplan-step1-2.png"  style="width: 70%;"/>

        </div>
    </div>
</div>
<style>
    q::before{
        color:#055D9D;
        display: block;
        content: open-quote;
        font-size: 2rem;
    }
    q{
        quotes: '\201c' '\201d';
        font-size: 20px;
    font-family: 'Karla';
    font-weight: bold;
    line-height: 32px;
    padding-left: 2rem
}

    q::after{
        color:#055D9D;
        display: block;
        content: close-quote;
        font-size: 2rem;
    }
</style>